import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("audio", {
    ref: "audioPlayer",
    class: "audio-player",
    controls: "",
    src: $options.fileURL,
    onEnded: _cache[0] || (_cache[0] = (...args) => ($options.handleEnded && $options.handleEnded(...args)))
  }, _toDisplayString($options.t('spreed', 'Your browser does not support playing audio files')), 41, _hoisted_1))
}